import React, { useState } from 'react';

import clsx from 'clsx';

import { SectionStatus, StatusSectionName } from 'components/accountStatus/accountStatus.enums';
import Button from 'components/common/Button/Button';
import Spinner from 'components/common/Spinner/Spinner';
import { ArrowRightIcon } from 'components/common/Icons/Icons';

import styles from './AccountStatusSection.module.scss';

interface AccountStatusSectionProps {
  name: StatusSectionName;
  status: SectionStatus;
  handleClick: () => void;
  statusText?: string;
}

const buttonTextToSectionName = {
  [StatusSectionName.ContractorRegistration]: 'Continue',
  [StatusSectionName.MasterDealerAgreement]: 'Get Started',
  [StatusSectionName.IntakeMeeting]: 'Schedule',
};

const AccountStatusSection = ({ name, status, handleClick, statusText }: AccountStatusSectionProps) => {
  const [isLoading, setLoading] = useState<boolean>(false);
  const sectionStatusClasses = clsx({
    [styles.sectionStatus]: true,
    [styles.complete]: status === SectionStatus.Complete,
    [styles.incomplete]: status !== SectionStatus.Complete,
  });
  const sectionStatus = status === SectionStatus.Complete ? SectionStatus.Complete : SectionStatus.Incomplete;
  const onClick = () => {
    setLoading(true);
    handleClick();
    setLoading(false);
  };
  const buttonText = buttonTextToSectionName[name];

  return (
    <div className={styles.block}>
      <div>
        <p>{name}:</p>
      </div>
      <div>
        <p className={sectionStatusClasses}>{sectionStatus}</p>
      </div>
      <div>
        {statusText ? (
          <div className={styles.statusTextWrapper}>
            <Spinner size={16} />
            <p className={styles.statusText}>{statusText}</p>
          </div>
        ) : (
          (status === SectionStatus.Active || status === SectionStatus.Disabled) && (
            <Button
              className={styles.button}
              onClick={onClick}
              isLoading={isLoading}
              disabled={status === SectionStatus.Disabled}
            >
              {buttonText}
              <ArrowRightIcon />
            </Button>
          )
        )}
      </div>
    </div>
  );
};

export default AccountStatusSection;
